// EGTS™ JS
document.addEventListener('DOMContentLoaded', function(){
  // Smooth scroll for anchor buttons
  document.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var id = this.getAttribute('href').slice(1);
      var el = document.getElementById(id);
      if(!el) return;
      e.preventDefault();
      var top = el.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({top:top, behavior:'smooth'});
    });
  });
});
